import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { setSelectedFeedback, ajaxFeedback, getRequestedVia, getStarsJSX, getChatStatus } from '../redux/FeedbackRedux';


class Typing extends React.Component {

	render () {
		return (
            <div className="typing_module_body">
                {this.props.state.typing_timer > 0 &&
                    <div className={"row typing_row " + (this.props.state.typing_is_business?"outgoing_msg":"incoming_msg")}>
                        <div className="col-md-2 col-4"></div>
                        <div className="col-md-8 col-8 pr-0">
                            <p className="chat_texts">
                                {this.props.state.typing_name + " is typing"}<span id="loading-dots">.</span>
                            </p>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(Typing)